<template>
    <v-layout fill-height column class="main-container template-padding" :class="$vuetify.breakpoint.xsOnly ? 'pb-10' : ''" >
        <div v-for="(item, itemIndex) in items" :key="itemIndex">
            <template v-if="item.type == 'banner' && itemIndex == 0">
                <v-container :class="outerContainer">
                    <v-text-field v-if="pageType == 'Canvas'" label="Image URL or Link" dense outlined v-model="item.image"></v-text-field>
                    <v-img contain :height="$vuetify.breakpoint.mdAndUp ? '600px' : undefined"
                        :src="item.image"
                    ></v-img>

                    <RowControls v-if="pageType == 'Canvas'" :rowIndex="itemIndex" />
                </v-container>
            </template>
            <div class="body-container">
                <template v-if="item.type == 'grids'">
                    <Grid2 :item="item" :key="gridKey"
                        :index="itemIndex"
                        :styles="{
                            text: 'body poppins mt-7 mb-7',
                            image: {
								contain: true,
								wrapper: '',
								class: '',
								height: 'auto',
								width: 'auto',
								maxWidth: '100%',
								maxHeight: '',
								custom: {
									margin: '0 auto'
								}
							},
                            heading1: {
                                wrapper: '',
                                classMobile: 'h5 rubik font-weight-bold white--text',
                                classLarge: 'h4 rubik font-weight-bold white--text',
                                after: '',
								guideWrapper: '',
								guideClass: 'ml-5'
                            },
                            heading2: {
                                wrapper: '',
                                classMobile: 'h4 antonio font-weight-bold pl-5 my-5',
                                classLarge: 'h3 antonio font-weight-bold pl-5',
                                after: '',
								guideWrapper: '',
								guideClass: 'ml-5'
                            },
                            textcard: {
                                outlined: true,
                                elevation: 0,
                                card: 'text-center pa-5 mb-5',
                                text: 'h5 rubik font-weight-bold my-3 text-center text-uppercase',
                                subtitle: 'small-text poppins text-center mt-5',
                                custom: {
                                }
                            },
                            imagecard: {
                                doubleCard: false,
                                elevation: 0,
                                outlined: false,
                                card: 'd-flex flex-column align-center text-center py-5 px-5 mb-3 mt-5',
                                imagePosition: 'top',
                                image: {
                                    height: '250px',
                                    width: imageWidth
                                },
                                text: 'gme-title antonio h5 font-weight-bold white--text',
                                subtitle: 'body karla pt-5 gme-subtitle',
                                custom: {

                                }
                            },
                            dialog: {
                                elevation: 0,
                                cardClass: 'py-5 px-5 my-5',
                                cardColor: '',
                                innerCard: '',
                                dialogTitle: '',
                                dialogName: 'rubik font-weight-bold gme-label1 mr-3',
                                textWrapper: 'body-poppins text-left responsive-text',
                                custom: {
                                    text: '',
                                    textClass: 'mt-3'
                                }
                            }
                        }"
                    />
                </template>
            </div>
        </div>
        <ImageUploader />
    </v-layout>
</template>

<script>
import RowControls from "@/components/RowControls.vue"
import ImageUploader from "@/components/ImageUploadModal.vue"
import { Grid2 } from "@/imports/elements.js"
import { highlights } from "@/mixins/highlights"
import responsiveHeight from "@/mixins/responsiveHeight"

export default {
    props: ["items"],
    mixins: [responsiveHeight, highlights],
    components: {
        RowControls, ImageUploader, Grid2
    },
    mounted () {
        this.getRangesFromDb()
    },
    computed: {
        bannerTextSize () {
            return this.$vuetify.breakpoint.smAndDown ? "h4" : "h3"
        },
        imageWidth () {
            return this.$vuetify.breakpoint.xsOnly ? "250px" : "300px"
        }
    },
    methods: {

    }
}
</script>
<style scoped>
.main-container {
  background: linear-gradient(to right top, #129490, #1bdad4);
}
.body-container {
  width: 100%;
}
.dialogue-label-b {
  color: #129490;
}
.vocabulary-text {
  position: absolute;
  bottom: 0;
}
.footer-img {
  background-color: #ffffff;
  width: max-content;
  border-radius: 20px;
}
</style>
